import pathify from 'vuex-pathify';

export default pathify;

// options
pathify.options.deep = 2;
